<template>
  <div class="recommend-content">
    <div class="edit-dialog-item">
      <p class="recommend-title">推荐要求</p>
      <pre>{{ company['推荐备注'] || '暂无数据'  }}</pre>
    </div>
    <div class="edit-dialog-item">
      <p class="recommend-title">其他特殊要求</p>
      <pre>{{ company['特殊要求寻访']  || '暂无数据' }}</pre>
    </div>
    <div class="edit-dialog-item">
      <p class="recommend-title">客户系统</p>
      <pre>{{ company['客户系统']  || '暂无数据' }}</pre>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    company: { type: Object, default: () => {} },
  },
  data() {
    return {
      contract: {},
    }
  },
  // watch: {
  //   company(newValue, oldValue) {
  //     if(newValue&&newValue._id){
  //       if (this.company.附件 && this.company.附件.length > 0) {
  //         this.company.附件.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
  //       }
  //       this.contract = (this.company.附件 || []).find(v => v.type === '合同') || {}
  //     }
  //   },
  // },
  methods: {
  },
}
</script>
<style>
.recommend-dialog .el-dialog__body {
  padding-top: 0px;
}
</style>
<style src="../../../../company/statistics/css/commonCompany.css" scoped></style>
<style scoped>
.recommend-content {
  display: flex;
  flex-direction: column;
}
.alert-box {
  padding: 10px 10px;
}
.edit-dialog-item {
  margin-bottom: 10px;
}
.recommend-title {
  font-size: 16px;
  font-weight: 600;
}
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  text-indent: 2em;
}
</style>
